import React from 'react';

import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {CourseSessionCertificate} from 'src/pages/Modules/Training/shared/CourseSessionCertificate/CourseSessionCertificate';
import {TrainingDocumentTitle} from 'src/app/training/courseContentValidation';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const CourseSessionCertificatePage: React.FC = () => {
  useSetDocumentTitle(TrainingDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Training}>
      <CourseSessionCertificate isAdminPath={false} />
    </ContentWrapper>
  );
};

// No module/operation gate — matches CourseSessionRecordPage. Regular
// trainees lack Training View permission; backend enforces self-or-Training-View.
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingSessionCertificate(':sessionId', ':contentId'),
  element: <CourseSessionCertificatePage />,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingSessionCertificate(':sessionId'),
  element: <CourseSessionCertificatePage />,
  isPrivate: true,
});

export default CourseSessionCertificatePage;
